import { h } from 'preact';
import { RectangleButtonWrapper } from './RectangleButton.styled';

const RectangleButton = props => <RectangleButtonWrapper {...props} />;

export default RectangleButton;
